module.exports = __webpack_public_path__ + "img/project-big-2.jpg?11dce3fb6e47c8d232056cec11ba8867";